import { Reveal } from "./Reveal";
import { audiences } from "@/data/site";

export const WhoFor = () => {
  return (
    <section id="per-chi" className="bg-linen py-24 sm:py-36" data-testid="who-its-for">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-sans-ui text-[11px] tracking-mega text-ink/40 mb-6">CAPITOLO 08 — PER CHI È</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-light text-ink text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-3xl mb-16">
            Costruito per chi vuole vendere moda sul serio.
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-px bg-[rgba(17,17,17,0.12)] border hairline">
          {audiences.map((a, i) => (
            <Reveal key={a.tag} delay={i * 0.05} className="bg-linen">
              <div className="p-8 sm:p-12 h-full group hover:bg-ivory transition-colors duration-500">
                <div className="flex items-baseline gap-4 mb-6">
                  <span className="font-display text-2xl text-ink/25">{a.tag}</span>
                  <span className="h-px flex-1 bg-[rgba(17,17,17,0.14)]" />
                </div>
                <h3 className="font-display text-3xl sm:text-4xl text-ink mb-5">{a.title}</h3>
                <p className="font-sans-ui text-sm sm:text-base text-ink/65 leading-relaxed max-w-md">{a.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
